import { TenantDaoService } from './../../dao/tenant-dao.service';
import { ChangeDetectorRef, Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { FormHelperService } from 'src/app/services/form-helper.service';
import { GlobalsService } from 'src/app/services/globals.service';
import { GoogleApiService } from 'src/app/services/google-api.service';
import { FullRoute, NavigateService } from 'src/app/services/navigate.service';
import { UtilService } from 'src/app/services/util.service';
import { ModalPage } from '../base/modal-page';
import { DialogService } from 'src/app/services/dialog.service';
import { DOCUMENT } from '@angular/common';
import { LogoItem } from 'src/app/dao/tenant-dao.service';
import { Tenant } from 'src/app/models/tenant.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, ModalPage, OnDestroy {

  public buttonDprfSeguranca: boolean = true;
  public error: string = "";
  public login: FormGroup;
  public redirectTo?: FullRoute;
  public bc?: BroadcastChannel;
  public logos: LogoItem[] = [];

  /* ModalPage interface */
  public modalRoute?: ActivatedRouteSnapshot;
  public modalInterface: boolean = true;
  public modalWidth: number = 400;
  public noSession: boolean = false;
  public titleSubscriber: Subject<string> = new Subject<string>();

  constructor(
    public gb: GlobalsService,
    public go: NavigateService,
    public router: Router,
    public cdRef: ChangeDetectorRef,
    public route: ActivatedRoute,
    public auth: AuthService,
    public util: UtilService,
    public fh: FormHelperService,
    public formBuilder: FormBuilder,
    public googleApi: GoogleApiService,
    public dialog: DialogService,
    private ten: TenantDaoService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.document.body.classList.add('login');
    this.login = this.fh.FormBuilder({
      usuario: { default: "" },
      senha: { default: "" },
      token: { default: "" }
    }, this.cdRef, this.validate);
  }

  public validate = (control: AbstractControl, controlName: string) => {
    let result = null;

    if (['senha', 'token'].indexOf(controlName) >= 0 && !control.value?.length) {
      result = "Obrigatório";
    } else if (controlName == "usuario" && !this.util.validarCPF(control.value)) {
      result = "Inválido";
    }

    return result;
  }

  public loadData(entity: Tenant) {
    if (entity) {
      if (entity._metadata && entity._metadata.logos && entity._metadata.logos.length) this.logos = entity._metadata!.logos;
    };
  }

  ngOnInit(): void {
    this.titleSubscriber.next("Login Petrvs");
    this.logos = this.gb.LOGOS;

    this.route.queryParams.subscribe(params => {
      this.error = params['error'] ? params['error'] : "";
      if (params["redirectTo"]) {
        let routerTo = JSON.parse(params["redirectTo"]);
        this.redirectTo = routerTo.route[0] == "login" ? routerTo : undefined;
      }
      this.noSession = !!params["noSession"];
    });
    /* Registra listner para logins com popup que necessitam de retorno */
    this.auth.registerPopupLoginResultListener();
    /* Verifica se o usuário não já está logado (login-session), e caso não esteja verifica tambem se algum dos login (Google, Microsoft, etc), estão com sessão ativas e tenta logar com essa sessão */
    (async () => {
      // Inicializa Google Auth e cria o botão na tela
      if (this.gb.hasGoogleLogin) {
        let res = await this.googleApi.initialize(true);//.then((res: any) => {
        res.renderButton(document.getElementById('gbtn') as HTMLElement, {
          size: 'large',
          width: 320,
        });
        //})
      }
      let result = false;
      if (!this.noSession) result = await this.auth.authSession();
      /* verifica tambem se algum dos login (Google, Microsoft, etc), estão com sessão ativas */
      if (!result) {
        if (this.gb.hasGoogleLogin) {
          var socialUser;
          try {
            socialUser = await this.googleApi.getLoginStatus();
          } catch (error) { }
          if (socialUser?.idToken) this.auth.authGoogle(socialUser?.idToken);
        }
        if (this.gb.hasAzureLogin) {
          // TODO: Implementa login automático
        }
      } else if (this.auth.success) {
        this.auth.success(this.auth.usuario!, this.redirectTo);
      }
    })();
  }

  public closeModalIfSuccess = (result: boolean) => {
    if (result && this.modalRoute) {
      this.go.clearRoutes();
    }
  };

  public openModal(item: any) {
    if(item.route) this.go.navigate({route: item.route, params: item.params}, {title: "Suporte Petrvs"});
  }

  public showDprfSeguranca() {
    this.buttonDprfSeguranca = !this.buttonDprfSeguranca;
  }

  public signInDprfSeguranca() {
    const form = this.login.controls;
    this.login.markAllAsTouched();
    if (this.login.valid) {
      this.auth.authDprfSeguranca(this.util.onlyNumbers(form.usuario.value), form.senha.value, this.util.onlyNumbers(form.token.value), this.redirectTo).then(this.closeModalIfSuccess);
    } else {
      this.error = "Verifique se está correto:" + (form.cpf.invalid ? " CPF;" : "") + (form.password.invalid ? " Senha;" : "") + (form.password.invalid ? " Token;" : "");
    }
  }

  public signInMicrosoft() {
    const form = this.login.controls;
    if (this.login.valid) {
      this.auth.authDprfSeguranca(form.usuario.value, form.senha.value, form.token.value, this.redirectTo).then(this.closeModalIfSuccess);
    } else {
      this.error = "Verifique se está correto:" + (form.cpf.invalid ? " CPF;" : "") + (form.password.invalid ? " Senha;" : "") + (form.password.invalid ? " Token;" : "");
    }
  }

  public signInAzure() {
    this.auth.authAzure();
  }

  public signInLoginUnicoBackEnd() {
    this.auth.authLoginUnicoBackEnd();    // chamado pelo botão no form de login
  }

  ngOnDestroy(){
    this.document.body.classList.remove('login');
  }

  public loginPetrvsPath() {
    let loginPetrvs = this.logos.find((logo: LogoItem) => logo.theme == 'petrvs')?.file;
    loginPetrvs = loginPetrvs?.length ? loginPetrvs : undefined;
    return loginPetrvs?.length ? this.gb.getResourcePath('assets/images/' + loginPetrvs) : this.gb.getResourcePath('assets/images/logo.png');
  }

  public loginImagemTenantPath() {
    let loginImagemTenantPath = this.logos.find((logo: LogoItem) => logo.theme == 'petrvs_login_imagem')?.file;
    loginImagemTenantPath = loginImagemTenantPath?.length ? loginImagemTenantPath : undefined;
    return loginImagemTenantPath?.length ? this.gb.getResourcePath('assets/images/' + loginImagemTenantPath, true) : this.gb.getResourcePath('assets/images/login_imagem.jpg', true);
  }

  public loginSimboloTenantPath() {
    let loginSimboloTenant = this.logos.find((logo: LogoItem) => logo.theme == 'petrvs_login_simbolo')?.file;
    loginSimboloTenant = loginSimboloTenant?.length ? loginSimboloTenant : undefined;
    return loginSimboloTenant?.length ? this.gb.getResourcePath('assets/images/' + loginSimboloTenant) : this.gb.getResourcePath('assets/images/login_simbolo.png');
  }

  public loginGovTenantPath() {
    let loginGovTenantPath = this.logos.find((logo: LogoItem) => logo.theme == 'petrvs_login_gov')?.file;
    loginGovTenantPath = loginGovTenantPath?.length ? loginGovTenantPath : undefined;
    return loginGovTenantPath?.length ? this.gb.getResourcePath('assets/images/' + loginGovTenantPath) : this.gb.getResourcePath('assets/images/login_gov.png');
  }
}
